module.exports = __webpack_public_path__ + "img/introduction02_about_03.3e45e236.png";